(() => {
  "use strict";
  if (!window.Lymko || window.__lk_search) return;
  window.__lk_search = 1;
  const L = window.Lymko, { $, $$, esc, money, reveal, markFavs, store, R, CFG } = L;
  const T = (k, d, o) => L.T ? L.T(k, d, o) : String(d).replace(/\[(\w+)\]/g, (m, x) => o && x in o ? o[x] : m);
  if (CFG.instant === false) return;
  let IDX = null, pending = null;
  const KEY = "lk_idx_" + (CFG.idxv || "1");
  const prep = (d) => {
    if (!d || !Array.isArray(d.p)) return null;
    const by = {};
    d.p.forEach((p) => {
      by[p.h] = p;
    });
    const conl = {};
    (d.con || []).forEach((c) => {
      conl[c.k] = c.t;
    });
    d.p.forEach((p) => {
      const items = (p.it || []).filter(Boolean).map((h) => by[h]).filter(Boolean);
      const ings = items.length ? items.map((q) => q.n + " " + (q.g || []).join(" ")).join(" ") : (p.g || []).join(" ");
      p.hay = [p.n, p.sub, p.cl, p.ty, p.sh, (p.c || []).map((c) => conl[c] || "").join(" "), (p.b || []).join(" "), ings, (p.tg || []).join(" ")].join(" ").toLowerCase();
      p.items = items;
    });
    d.by = by;
    d.conl = conl;
    return d;
  };
  const fromDoc = (root) => {
    const el = root.querySelector("#lk-idx");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  };
  function load() {
    if (IDX) return Promise.resolve(IDX);
    const inline = fromDoc(document);
    if (inline) {
      IDX = prep(inline);
      if (IDX) return Promise.resolve(IDX);
    }
    try {
      const c = JSON.parse(sessionStorage.getItem(KEY) || "null");
      if (c && Date.now() - c.t < 15 * 60 * 1e3) {
        IDX = prep(c.d);
        if (IDX) return Promise.resolve(IDX);
      }
    } catch (e) {
    }
    if (pending) return pending;
    pending = fetch(`${R.root}${R.root.includes("?") ? "&" : "?"}section_id=lk-search-index`, { credentials: "same-origin" }).then((r) => r.ok ? r.text() : Promise.reject(r.status)).then((html) => {
      const d = fromDoc(new DOMParser().parseFromString(html, "text/html"));
      if (!d) throw new Error("no index");
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d }));
      } catch (e) {
      }
      IDX = prep(d);
      return IDX;
    }).catch((e) => {
      pending = null;
      throw e;
    });
    return pending;
  }
  function searchAll(v) {
    v = v.trim().toLowerCase().replace(/\s+/g, " ");
    if (!v || !IDX) return [];
    const w = v.split(" ").filter((x) => x.length > 1);
    const phrase = IDX.p.some((p) => p.hay.includes(v));
    return IDX.p.map((p) => {
      const h = p.hay, n = p.n.toLowerCase();
      if (phrase ? !h.includes(v) : !(w.length && w.every((x) => h.includes(x)))) return null;
      let s = 0;
      if (n.includes(v)) s += 10;
      if (n.startsWith(v)) s += 5;
      if (!p.cb) s += 3;
      if (p.ri) s += 1;
      return [p, s];
    }).filter(Boolean).sort((a, b) => b[1] - a[1]).map((x) => x[0]);
  }
  function blocks(v) {
    const l = searchAll(v), vv = v.trim().toLowerCase();
    if (!vv || !IDX) return { l, cats: [], cons: [], ig: [], arts: [] };
    const cats = (IDX.cols || []).filter((c) => c.t.toLowerCase().includes(vv) || c.h.includes(vv) || vv.length > 2 && (c.p || []).some((h) => IDX.by[h] && (IDX.by[h].ty || "").toLowerCase().includes(vv)));
    const cons = (IDX.con || []).filter((c) => c.u && c.t.toLowerCase().includes(vv));
    const ig = (IDX.ing || []).filter((g) => (g.t + " " + (g.y || "")).toLowerCase().includes(vv));
    const arts = (IDX.art || []).filter((a) => (a.t + " " + (a.l || "")).toLowerCase().includes(vv));
    return { l, cats, cons, ig, arts };
  }
  const hlt = (t, v) => {
    if (!v) return esc(t);
    const i = t.toLowerCase().indexOf(v.toLowerCase());
    return i < 0 ? esc(t) : esc(t.slice(0, i)) + '<mark class="hl">' + esc(t.slice(i, i + v.length)) + "</mark>" + esc(t.slice(i + v.length));
  };
  const pkb = (p) => {
    if (p.items && p.items.length > 1 && !p.own) return `<span class="pk-box"><div class="combo-ph">${p.items.map((q) => `<img src="${esc(q.im)}" alt="${esc(q.n)}" loading="lazy" width="400" height="560">`).join("")}</div></span>`;
    return `<span class="pk-box">${p.im ? `<img src="${esc(p.im)}" alt="${esc(p.n)}" loading="lazy" width="560" height="800">` : ""}</span>`;
  };
  const price = (p) => p.ps || money(p.pr);
  const mcard = (p, v) => `<a class="mcard" href="${esc(p.u)}"${v ? ` data-sv="${esc(v)}"` : ""}><span class="im" style="background:${esc(p.tn || "#F7F6F4")};display:block">${pkb(p)}</span><b>${hlt(p.n, v)}</b><span>${esc(price(p))}${p.ty ? " · " + esc(p.ty) : ""}</span></a>`;
  const plural = (n, one, many) => (n === 1 ? one : many).replace("[count]", n);
  const linkRows = (b, page, lb) => {
    lb = lb || {};
    const row = (lab, links) => page ? `<span class="lab">${esc(lab)}</span><div class="cc">${links}</div><div style="height:30px"></div>` : `<div style="margin-top:30px"><span class="lab">${esc(lab)}</span><div class="cc" style="margin-top:12px">${links}</div></div>`;
    let h = "";
    if (b.cats.length || b.cons.length) h += row(lb.cats || T("s_cats", "Categories & concerns"), b.cats.map((c) => `<a href="${esc(c.u)}">${esc(c.t)}</a>`).join("") + b.cons.map((c) => `<a href="${esc(c.u)}">${esc(c.t)}</a>`).join(""));
    if (b.ig.length) h += row(lb.ings || T("s_ings", "Ingredients"), b.ig.map((g) => `<a href="${esc(g.u)}">${esc(g.t)}</a>`).join(""));
    if (b.arts.length) h += row(lb.arts || T("s_arts", "Articles"), b.arts.map((a) => `<a href="${esc(a.u)}">${esc(a.t)}</a>`).join(""));
    return h;
  };
  const searchUrl = (v) => `${R.search}?q=${encodeURIComponent(v)}&type=product&options%5Bprefix%5D=last`;
  const popular = () => (Array.isArray(CFG.popular) ? CFG.popular : []).map((s) => String(s).trim()).filter(Boolean);
  function overlay(q) {
    const out = $("#ores");
    if (!out) return;
    const v = (q || "").trim();
    if (!v) {
      const t = $("#otrend");
      out.innerHTML = t ? t.innerHTML : "";
      return;
    }
    if (!IDX) {
      load().then(() => {
        const cur = $("#oq");
        if (cur && cur.value.trim() === v) overlay(v);
      }).catch(() => {
      });
      return;
    }
    const b = blocks(v), lim = 8;
    out.innerHTML = b.l.length || b.cats.length || b.cons.length || b.ig.length || b.arts.length ? `<span class="lab" style="display:block;margin-bottom:16px">${esc(plural(b.l.length, T("s_one", "[count] product for"), T("s_many", "[count] products for")))} “${esc(v)}”</span>
        ${b.l.length ? `<div class="sres">${b.l.slice(0, lim).map((p) => mcard(p, v)).join("")}</div>` : ""}
        ${b.l.length > lim ? `<a class="btn btn-k sm" style="margin-top:20px" href="${searchUrl(v)}" data-sv="${esc(v)}">${esc(T("s_all", "View all [count] results", { count: b.l.length }))}</a>` : ""}
        ${linkRows(b, false)}` : `<div class="empty" style="padding:30px 0;text-align:left"><h3 class="h3">${esc(T("s_none", "No results for"))} “${esc(v)}”.</h3><p style="margin-top:10px">${esc(T("s_none_hint", "Check the spelling, or try one of the popular searches."))}</p><div class="cc">${popular().slice(0, 5).map((s) => `<button type="button" data-sq="${esc(s)}" style="padding:10px 18px;border-radius:99px;border:1px solid var(--line)">${esc(s)}</button>`).join("")}</div></div>`;
  }
  function searchPage() {
    /* Search page: instant results + the same filters and sort as the shop (category, concern, skin type, product type,
       price, availability, highlights). Filter counts follow the current search; chips, "Clear all", load more,
       mobile filter sheet and browser back/forward all keep working. */
    const wrap = $("[data-lk-search]");
    if (!wrap || wrap.dataset.lkBound) return;
    wrap.dataset.lkBound = 1;
    const q = $("#sq", wrap), cnt = $("#scount", wrap), grid = $("#sgrid", wrap), sing = $("#sing", wrap), more = $("#more", wrap);
    const filt = $("#filt", wrap), fbox = filt && $("[data-lk-fgroups]", filt), fsel = $("#fsel", wrap), sort = $("#sort", wrap);
    let cfg = {};
    try {
      cfg = JSON.parse(($("#lk-scfg", wrap) || {}).textContent || "{}");
    } catch (e) {
    }
    const L3 = cfg.l || {};
    const pool = {};
    const tpl = $("#spool", wrap);
    if (tpl) [...tpl.content.children].forEach((c) => {
      if (c.dataset.h) pool[c.dataset.h] = c;
    });
    const spop = $("#spop", wrap);
    const popRoot = spop ? spop.content : new URLSearchParams(location.search).get("q") ? null : grid;
    const popH = popRoot ? [...popRoot.querySelectorAll("[data-h]")].map((c) => c.dataset.h) : [];
    const L2 = wrap.dataset;
    const PER = Math.max(+L2.per || 48, 12);
    const card = (p) => {
      const c = pool[p.h];
      return c ? c.outerHTML : mcard(p, "");
    };
    const tl = (s) => String(s || "").toLowerCase();
    const off = (p) => p.m > 0 ? Math.round((1 - p.pr / p.m) * 100) : 0;
    const ST = cfg.skin && cfg.skin.length ? cfg.skin : ["Oily", "Dry", "Combination", "Normal", "Sensitive"];
    const buckets = (cfg.prices || []).map((x) => [x.v, x.l]);
    const FG = [
      ["cat", L3.cat || "Category", () => (IDX.cols || []).filter((c) => c.h !== "best-selling").map((c) => [c.h, c.t]), (p, v) => (p.co || []).includes(v)],
      ["con", L3.con || "Concern", () => (IDX.con || []).map((c) => [c.k, c.t]), (p, v) => (p.c || []).includes(v)],
      ["st", L3.st || "Skin type", () => ST.map((s) => [s, s]), (p, v) => (p.st || []).map(tl).includes(tl(v))],
      ["type", L3.type || "Product type", () => (cfg.types || []).map((t) => [t, t]), (p, v) => tl(p.ty) === tl(v)],
      ["pr", L3.pr || "Price", () => buckets, (p, v) => {
        const [a, b] = v.split("-");
        const r = p.pr / 100;
        return r >= +a && r <= +b;
      }],
      ["av", L3.av || "Availability", () => [["in", L3.in || "In stock"]], (p) => !!p.av],
      ["hl", L3.hl || "Highlights", () => {
        const h = (L3.hlo || []).map((x) => String(x).trim());
        return [["best", h[0] || "Best seller"], ["feat", h[1] || "Featured"], ["combo", h[2] || "Combo"], ["d30", h[3] || "30% off or more"], ["d40", h[4] || "40% off or more"]];
      }, (p, v) => v === "best" ? p.bs : v === "feat" ? p.ft : v === "combo" ? p.cb : v === "d30" ? off(p) >= 30 : off(p) >= 40]
    ];
    let FS = {}, base = [], rank = new Map(), vNow = "", shown = PER;
    const passes = (p, skip) => FG.every((g) => g[0] === skip || !FS[g[0]] || !FS[g[0]].length || FS[g[0]].some((v) => g[3](p, v)));
    const labelOf = (g, v) => {
      const G = FG.find((x) => x[0] === g);
      const o = G && G[2]().find((x) => x[0] === v);
      return o ? o[1] : v;
    };
    const renderGroups = () => {
      if (!fbox) return;
      const html = FG.map((g) => {
        const sel = FS[g[0]] || [];
        const opts = g[2]().map(([v, l]) => [v, l, base.filter((p) => passes(p, g[0]) && g[3](p, v)).length]).filter((o) => o[2] > 0 || sel.includes(o[0]));
        if (!opts.length) return "";
        return `<div class="fg"><h5>${esc(g[1])}</h5>${opts.map(([v, l, n]) => `<label${n ? "" : ' class="dis"'}><input type="checkbox" data-f="${g[0]}|${esc(v)}"${sel.includes(v) ? " checked" : ""}>${esc(l)}<em>${n}</em></label>`).join("")}</div>`;
      }).join("");
      fbox.innerHTML = html ? html + `<button type="button" class="link" id="fclear" style="margin-top:16px">${esc(L3.clear_all || "Clear all filters")}</button>` : `<p class="hl-note" style="padding:6px 0">${esc(L3.no_filters || "Search for a product to filter the results.")}</p>`;
    };
    const current = () => {
      const l = base.filter((p) => passes(p));
      const s = sort ? sort.value : "f";
      const r = (a, b) => rank.get(a.h) - rank.get(b.h);
      if (s === "l") l.sort((a, b) => a.pr - b.pr || r(a, b));
      else if (s === "h") l.sort((a, b) => b.pr - a.pr || r(a, b));
      else if (s === "o") l.sort((a, b) => off(b) - off(a) || r(a, b));
      else if (s === "a") l.sort((a, b) => a.n.localeCompare(b.n));
      else l.sort(r);
      return l;
    };
    const draw = () => {
      const l = current();
      const nf = Object.keys(FS).length;
      if (vNow) cnt.textContent = (l.length === 1 ? L2.one || "[count] product for “[q]”" : L2.many || "[count] products for “[q]”").replace("[count]", l.length).replace("[q]", vNow);
      else cnt.textContent = nf ? (l.length === 1 ? L3.showing_one || "[count] product" : L3.showing_n || "[count] products").replace("[count]", l.length) : L2.popular || "Popular products";
      if (l.length) grid.innerHTML = l.slice(0, shown).map(card).join("");
      else if (base.length) grid.innerHTML = `<div class="empty lk-empty" style="grid-column:1/-1;padding:40px 0;text-align:left"><h2 class="h3">${esc(L3.empty_title || "No products match these filters.")}</h2><p style="margin-top:10px">${esc(L3.empty_text || "Try removing a filter.")}</p><button type="button" class="btn btn-k sm" style="margin-top:20px" data-fclear2>${esc(L3.clear || "Clear filters")}</button></div>`;
      else grid.innerHTML = `<div style="grid-column:1/-1"><h2 class="h3">${esc((L2.empty || "No products found for “[q]”.").replace("[q]", vNow))}</h2><p style="color:var(--muted);margin-top:8px">${esc(L2.hint || "")}</p></div>`;
      if (fsel) fsel.innerHTML = Object.entries(FS).flatMap(([g, vs]) => vs.map((v) => `<button type="button" data-unf="${g}|${esc(v)}" aria-label="${esc((L3.remove || "Remove filter") + " " + labelOf(g, v))}">${esc(labelOf(g, v))} ✕</button>`)).join("");
      if (more) more.innerHTML = l.length > shown ? `<small>${esc((L3.viewed || "You’ve viewed [shown] of [count]").replace("[shown]", shown).replace("[count]", l.length))}</small><div class="bar2"><i style="width:${shown / l.length * 100}%"></i></div><button type="button" class="btn btn-l" id="lmore">${esc(L2.more || "Load more")}</button>` : "";
      wrap.classList.toggle("lk-noresults", !base.length);
      reveal(wrap);
      markFavs();
    };
    const go = (raw, save) => {
      const v = (raw || "").trim();
      if (save) saveRecent(v);
      vNow = v;
      if (v) {
        const b = blocks(v);
        base = b.l;
        sing.innerHTML = linkRows(b, true, L2);
      } else {
        base = popH.map((h) => IDX.by[h]).filter(Boolean);
        sing.innerHTML = "";
      }
      rank = new Map(base.map((p, i) => [p.h, i]));
      shown = PER;
      renderGroups();
      draw();
      const u = v ? searchUrl(v) : R.search;
      try {
        history.replaceState(history.state, "", u);
      } catch (e) {
      }
    };
    const clearF = () => {
      FS = {};
      shown = PER;
      renderGroups();
      draw();
    };
    if (filt) {
      filt.addEventListener("change", (e) => {
        const i = e.target.closest("[data-f]");
        if (!i) return;
        const [g, v] = i.dataset.f.split("|");
        FS[g] = FS[g] || [];
        FS[g] = i.checked ? [...FS[g].filter((x) => x !== v), v] : FS[g].filter((x) => x !== v);
        if (!FS[g].length) delete FS[g];
        shown = PER;
        renderGroups();
        draw();
      });
      filt.addEventListener("click", (e) => {
        if (e.target.closest("#fclear")) {
          e.preventDefault();
          clearF();
        }
      });
    }
    wrap.addEventListener("click", (e) => {
      const b = e.target.closest("[data-unf]");
      if (b) {
        e.preventDefault();
        const [g, v] = b.dataset.unf.split("|");
        FS[g] = (FS[g] || []).filter((x) => x !== v);
        if (!FS[g].length) delete FS[g];
        shown = PER;
        renderGroups();
        draw();
        return;
      }
      if (e.target.closest("[data-fclear2]")) {
        e.preventDefault();
        clearF();
        return;
      }
      if (e.target.closest("#lmore")) {
        e.preventDefault();
        shown += PER;
        draw();
      }
    });
    if (sort) sort.addEventListener("change", () => {
      shown = PER;
      draw();
    });
    let rt;
    q.addEventListener("input", () => {
      go(q.value);
      clearTimeout(rt);
      rt = setTimeout(() => saveRecent(q.value), 1500);
    });
    q.form.addEventListener("submit", (e) => {
      e.preventDefault();
      go(q.value, true);
      q.blur();
    });
    $$(".sugg a, .sugg [data-sq]", wrap).forEach((a) => a.addEventListener("click", (e) => {
      e.preventDefault();
      const v = a.dataset.sq || new URL(a.href, location.origin).searchParams.get("q") || "";
      q.value = v;
      go(v, true);
    }));
    addEventListener("popstate", () => {
      const v = new URLSearchParams(location.search).get("q") || "";
      q.value = v;
      go(v);
    });
    const start = () => {
      go(q.value, !!q.value.trim());
      if (!q.value && q.hasAttribute("data-autofocus")) setTimeout(() => q.focus({ preventScroll: true }), 300);
    };
    load().then(start).catch(() => {
      delete wrap.dataset.lkBound;
    });
  }

  const saveRecent = (v) => {
    v = (v || "").trim();
    if (v.length < 2) return;
    const r = store.get("lk_recent", []);
    store.set("lk_recent", [v, ...r.filter((x) => x.toLowerCase() !== v.toLowerCase())].slice(0, 6));
  };
  function shop() {
    const wrap = $("[data-lk-filter]");
    if (!wrap || wrap.dataset.lkBound) return;
    wrap.dataset.lkBound = 1;
    let cfg = {};
    try {
      cfg = JSON.parse(($("#lk-fcfg", wrap) || {}).textContent || "{}");
    } catch (e) {
    }
    const grid = $("#sgrid", wrap), more = $("#more", wrap), filt = $("#filt", wrap), fsel = $("#fsel", wrap) || $(".chipsel", wrap), fcnt = $(".cnt2", wrap), sort = $("#sort", wrap);
    const cards = $$("[data-h]", grid);
    const PAGE = +cfg.per || 12;
    const order = cards.map((c) => c.dataset.h);
    const el = {};
    cards.forEach((c) => {
      el[c.dataset.h] = c;
    });
    load().then(() => {
      const recs = order.map((h, i) => Object.assign({ _i: i }, IDX.by[h] || { h, n: el[h].textContent.trim(), pr: 0, m: 0, c: [], st: [], co: [], ty: "", av: true }));
      const off = (p) => p.m > 0 ? Math.round((1 - p.pr / p.m) * 100) : 0;
      const tl = (s) => String(s || "").toLowerCase();
      const ST = cfg.skin || ["Oily", "Dry", "Combination", "Normal", "Sensitive"];
      const buckets = (cfg.prices || []).map((x) => [x.v, x.l]);
      const L3 = cfg.l || {};
      const FG = [
        ["cat", L3.cat || "Category", () => (IDX.cols || []).filter((c) => c.h !== "best-selling").map((c) => [c.h, c.t]), (p, v) => (p.co || []).includes(v), !cfg.all],
        ["con", L3.con || "Concern", () => (IDX.con || []).map((c) => [c.k, c.t]), (p, v) => (p.c || []).includes(v)],
        ["st", L3.st || "Skin type", () => ST.map((s) => [s, s]), (p, v) => (p.st || []).map(tl).includes(tl(v))],
        ["type", L3.type || "Product type", () => (cfg.types || []).map((t) => [t, t]), (p, v) => tl(p.ty) === tl(v)],
        ["pr", L3.pr || "Price", () => buckets, (p, v) => {
          const [a, b] = v.split("-");
          const r = p.pr / 100;
          return r >= +a && r <= +b;
        }],
        ["av", L3.av || "Availability", () => [["in", L3.in || "In stock"]], (p) => !!p.av],
        ["hl", L3.hl || "Highlights", () => {
          const h = (L3.hlo || []).map((x) => String(x).trim());
          return [["best", h[0] || "Best seller"], ["feat", h[1] || "Featured"], ["combo", h[2] || "Combo"], ["d30", h[3] || "30% off or more"], ["d40", h[4] || "40% off or more"]];
        }, (p, v) => v === "best" ? p.bs : v === "feat" ? p.ft : v === "combo" ? p.cb : v === "d30" ? off(p) >= 30 : off(p) >= 40]
      ];
      let FS = {}, shown = PAGE;
      const groups = FG.filter((g) => !g[4]).map((g) => {
        const opts = g[2]().map(([v, l]) => [v, l, recs.filter((p) => g[3](p, v)).length]).filter((o) => o[2] > 0);
        if (!opts.length) return "";
        return `<div class="fg"><h5>${esc(g[1])}</h5>${opts.map(([v, l, n]) => `<label><input type="checkbox" data-f="${g[0]}|${esc(v)}">${esc(l)}<em>${n}</em></label>`).join("")}</div>`;
      }).join("");
      const fbox = $("[data-lk-fgroups]", filt);
      if (fbox) fbox.innerHTML = groups + `<button type="button" class="link" id="fclear" style="margin-top:16px">${esc(L3.clear_all || "Clear all filters")}</button>`;
      const labelOf = (g, v) => {
        const G = FG.find((x) => x[0] === g);
        const o = G && G[2]().find((x) => x[0] === v);
        return o ? o[1] : v;
      };
      const draw = () => {
        let l = recs.filter((p) => FG.every((g) => {
          const s2 = FS[g[0]];
          return !s2 || !s2.length || s2.some((v) => g[3](p, v));
        }));
        const s = sort ? sort.value : "f";
        if (s === "l") l.sort((a, b) => a.pr - b.pr || a._i - b._i);
        else if (s === "h") l.sort((a, b) => b.pr - a.pr || a._i - b._i);
        else if (s === "o") l.sort((a, b) => off(b) - off(a) || a._i - b._i);
        else if (s === "a") l.sort((a, b) => a.n.localeCompare(b.n));
        else l.sort((a, b) => a._i - b._i);
        if (fcnt) fcnt.textContent = (l.length === 1 ? (L3.showing || "Showing [shown] of [count] products").replace("products", "product") : L3.showing || "Showing [shown] of [count] products").replace("[shown]", Math.min(shown, l.length)).replace("[count]", l.length);
        if (fsel) fsel.innerHTML = Object.entries(FS).flatMap(([g, vs]) => vs.map((v) => `<button type="button" data-unf="${g}|${esc(v)}" aria-label="${esc((L3.remove || "Remove filter") + " " + labelOf(g, v))}">${esc(labelOf(g, v))} ✕</button>`)).join("");
        const vis = new Set(l.slice(0, shown).map((p) => p.h));
        l.forEach((p) => {
          const c = el[p.h];
          if (c) grid.appendChild(c);
        });
        cards.forEach((c) => {
          c.hidden = !vis.has(c.dataset.h);
          if (!c.hidden) c.classList.add("in");
        });
        let emp = $(".lk-empty", grid);
        if (!l.length) {
          if (!emp) {
            grid.insertAdjacentHTML("beforeend", `<div class="empty lk-empty" style="grid-column:1/-1;padding:40px 0"><h2 class="h3">${esc(L3.empty_title || "No products match these filters.")}</h2><p style="margin-top:10px">${esc(L3.empty_text || "Try removing a filter.")}</p><button type="button" class="btn btn-k sm" style="margin-top:20px" data-fclear2>${esc(L3.clear || "Clear filters")}</button></div>`);
          }
        } else if (emp) emp.remove();
        if (more) more.innerHTML = l.length > shown ? `<small>${esc((L3.viewed || "You’ve viewed [shown] of [count]").replace("[shown]", shown).replace("[count]", l.length))}</small><div class="bar2"><i style="width:${shown / l.length * 100}%"></i></div><button type="button" class="btn btn-l" id="lmore">${esc(L3.more || "Load more")}</button>` : l.length > PAGE ? `<small>${esc((L3.viewed_all || "You’ve viewed all [count] products").replace("[count]", l.length))}</small>` : "";
        wrap.classList.add("lk-ready");
        reveal(wrap);
        markFavs();
      };
      const clear = () => {
        FS = {};
        $$("input[data-f]", filt).forEach((i) => {
          i.checked = false;
        });
        shown = PAGE;
        draw();
      };
      filt.addEventListener("change", (e) => {
        const i = e.target.closest("[data-f]");
        if (!i) return;
        const [g, v] = i.dataset.f.split("|");
        FS[g] = FS[g] || [];
        FS[g] = i.checked ? [...FS[g].filter((x) => x !== v), v] : FS[g].filter((x) => x !== v);
        if (!FS[g].length) delete FS[g];
        shown = PAGE;
        draw();
      });
      filt.addEventListener("click", (e) => {
        if (e.target.closest("#fclear")) {
          e.preventDefault();
          clear();
        }
      });
      wrap.addEventListener("click", (e) => {
        const b = e.target.closest("[data-unf]");
        if (b) {
          e.preventDefault();
          const [g, v] = b.dataset.unf.split("|");
          FS[g] = (FS[g] || []).filter((x) => x !== v);
          if (!FS[g].length) delete FS[g];
          const inp = $$("input[data-f]", filt).find((x) => x.dataset.f === b.dataset.unf);
          if (inp) inp.checked = false;
          draw();
          return;
        }
        if (e.target.closest("[data-fclear2]")) {
          e.preventDefault();
          clear();
          return;
        }
        if (e.target.closest("#lmore")) {
          e.preventDefault();
          shown += PAGE;
          draw();
        }
      });
      if (sort) sort.addEventListener("change", () => {
        shown = PAGE;
        draw();
      });
      draw();
    }).catch(() => {
      wrap.classList.add("lk-ready");
      cards.forEach((c) => {
        c.hidden = false;
      });
    });
  }
  L.S = { load, searchAll, blocks, overlay, ready: () => !!IDX, on: true };
  const init = () => {
    searchPage();
    shop();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", () => {
    IDX = null;
    pending = null;
    init();
  });
  const warm = () => load().catch(() => {
  });
  ["pointerover", "focusin", "touchstart"].forEach((ev) => document.addEventListener(ev, (e) => {
    if (!IDX && e.target.closest && e.target.closest('[data-open="search"], #oq, a[href*="/search"]')) warm();
  }, { passive: true }));
})();
